import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { icons } from './assets/icons'
import './assets/css/agency.min.css'
import { Provider } from 'react-redux'
import store from './store'

import ReactGA from 'react-ga'
React.icons = icons;
ReactGA.initialize(process.env.REACT_APP_TRACKING_ID); // add your tracking id here.
ReactGA.pageview(window.location.pathname + window.location.search);

// console.log(process.env.REACT_APP_TRACKING_ID);

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
